/**
 * TanStack Query placeholder：仅在同一 workspaceId 下保留上一帧，避免换空间闪旧数据。
 *
 * Callers: tiktok-integration queryOptions、governance audit
 */

type QueryKeyCarrier = {
  queryKey: readonly unknown[];
};

/**
 * `queryKey` 约定为 `["workspace", workspaceId, …]`。
 * 关闭在 options 工厂上的 `workspaceId`，与 previousQuery 第二段比对。
 */
export function keepPreviousDataForWorkspace(workspaceId: string) {
  return <T,>(
    previousData: T | undefined,
    previousQuery: QueryKeyCarrier | undefined,
  ): T | undefined => {
    if (previousData === undefined || previousQuery === undefined) {
      return undefined;
    }
    if (previousQuery.queryKey[1] !== workspaceId) {
      return undefined;
    }
    return previousData;
  };
}
